import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitByLetter',
  standalone: true
})
export class SplitByLetterPipe implements PipeTransform {
  transform(value: string): string[] {
    return value ? value.split('') : [];
  }
}
